module.exports = "/static/assets/62bf6bfa8f606e548903e05a9c00c930.png";